var dom = {},

	$ = (typeof window !== "undefined" ? window.jQuery : typeof global !== "undefined" ? global.jQuery : null),

	state = {},

	scrollToElement = require('scroll-to-element'),

	setupDom = function(){

		dom.document = $(document);
		dom.loginForm = $(".login-form");
		dom.form = $("#theform");
		dom.countryCode = $("#country_code");
		dom.provinces = $("#provinces");

	},

	setupInitialState = function(){

		state.isModalOpened = false;
		state.fieldToFocus = "";

	},

	addEventHandlers = function(){

		dom.document.on("click", ".submit:not(.disabled)", function(e){

			var $btn = $(this);

			$btn.closest("form").submit();

			setBtnToProcessingState($btn);

			e.preventDefault();

		});

		dom.document.on("click", ".submit.disabled", function(e){

			e.preventDefault();

		});

		dom.document.on("click", ".home-contact-us-btn", function(e){

			e.preventDefault();

			$('.contact-wrapper').css({
				height: 'auto'
			});

			scrollToElement({
				element: '.contact-wrapper',
				force: true
			});

		});

		dom.loginForm.on("keypress", "input", function(e){

			if(e.which === 13){

				setBtnToProcessingState($(this).closest("form").find(".submit"));

				dom.loginForm.submit();

			}

		});

		dom.document.on("jqm_modal_closed", function(e){

			setBtnsToReadyState();

			e.preventDefault();

		});

		dom.document.on("form_alert_opened", function(e){

			state.isModalOpened = true;

			if(typeof e.field !== "undefined"){

				state.fieldToFocus = e.field;
				
			}

		});

		dom.document.on("jqm_modal_closed", function(){

			if(state.isModalOpened) {

				if(state.fieldToFocus.length){

					console.log(dom.form.find("[name='" + state.fieldToFocus + "']"));
					dom.form.find("[name='" + state.fieldToFocus + "']").focus();
				
				}

				state.isCheckoutModalOpened = false;

			}

		});

		dom.countryCode.on("change", function(){

			// update the provinces (there is a helper in the web root for this)
			$.ajax({

				url: "/provinces_json.cfm",
				type: "POST",
				data: {
					country_code: $(this).val()
				},
				success: function(){

					var provinceHtml = "",
						provinces = arguments[0].provinces,
						i;

					for(i = 0; i < provinces.length; i++){

						provinceHtml = provinceHtml + "<option value='" + provinces[i].code + "'>" + provinces[i].name + "</option>";

					}

					dom.provinces.html(provinceHtml);

				}

			});

		});

	},

	setBtnToProcessingState = function($btn){

		$btn.addClass("disabled");

		$btn.find(".label").text("processing...");

	},

	setBtnsToReadyState = function(){

		$(".submit.disabled")
			.removeClass("disabled")
			.find(".label")
			.text("submit");

	},

	init = function(){

		setupDom();

		setupInitialState();

		addEventHandlers();

	};

init();